import { useState, useCallback } from 'react'

export function usePagination(perPage = 15) {
  const [page, setPage] = useState(1)

  const reset = useCallback(() => setPage(1), [])

  return { page, perPage, setPage, reset }
}
